import { required } from './required';

let cached: string | null = null;

export const getApiBaseUrl = (): string => {
    if (cached !== null) {
        return cached;
    }
    cached = required(globalThis.import_meta_env.VITE_API_URL as string | undefined, 'VITE_API_URL').replace(/\/+$/, '');
    return cached;
};

export const migrationsEnabled = (): boolean => (globalThis.import_meta_env.VITE_MIGRATIONS_ENABLED as string | undefined) === 'true';
